export default __webpack_public_path__ + "static/media/logo.19ab1055.png";